import AppFooter from '@/components/widgets/Footer'
import axios from 'axios'

export default {
  name: 'AppHome',
  components: { AppFooter },
  data () {
    let pname = window.localStorage.getItem('player.name')
    if (!pname) pname = ''

    return {
      playerName: pname,
      server: 'Loading...',
      servers: []
    }
  },
  mounted () {
    axios.get('/servers.json').then(r => {
      /* r.data.forEach(s => {
        s.url = s.url
          .replace(/\$\{SCHEMA\}/, schema)
          .replace(/\$\{HOST\}/, host)
      }) */
      this.servers = r.data
      let defaultServer

      let serv = window.localStorage.getItem('player.server.4')
      if (!serv) {
        serv = navigator.language
        defaultServer = this.servers.find(s => s.id === serv)
        if (!defaultServer) {
          serv = navigator.language.substr(0, 2)
          defaultServer = this.servers.find(s => s.id === serv)
        }
      } else {
        defaultServer = this.servers.find(s => s.id === serv)
      }

      this.server = defaultServer || this.servers[0] // find lang or 'en'
    })

    // THE ADS
    window.aiptag.cmd.display.push(function () {
      window.aipDisplayTag.display('typenconquer-io_300x250')
    })
  },
  methods: {
    onSubmit (ev) {
      window.localStorage.setItem('player.name', this.playerName)
      window.localStorage.setItem('player.server.4', this.server.id)

      window.location = this.server.url
      // this.$router.push(this.server.url)
    }
  }
}
